import validateInitialization from "../../../core/js/helpers/validate-initialization";
import { createStore, reducers, renderState, actions } from "../../../core/js/state-machine";
import { componentName, componentClasses, views } from "../../../core/components/select/select";
import { chevronDown, alertNotice } from "../../../core/js/helpers/built-in-icons.js";

/**
 * Markup validation
 */
const validateHTML = (element) => {
    const selectWrapper = element.querySelector(`.${componentClasses.wrapper}`);

    if (!selectWrapper) {
        console.error(`${componentName} requires ${componentClasses.wrapper} element"`);
        return;
    }

    const select = selectWrapper.querySelector(`.${componentClasses.field}`);
    if (!select) {
        console.error(`${componentName} requires ${componentClasses.field} element"`);
        return;
    }
    // If no options exist, then log error and return false
    if (select.options.length === 0) {
        console.error(`${componentName} has no options available`);
        return;
    }

    return { selectWrapper, select };
};

/**
 * Creates Select
 * @param {HTMLElement} node
 * @returns Select
 */
const Select = (element) => {
    const [success, mergedProps, validElements] = validateInitialization({
        componentName,
        element,
        mergedProps,
        validateHTML,
    });
    if (!success) return;

    /**
     * The select tag doesn't have a default placeholder option, because it is always filled with an option.
     * So to mimic the a placeholder behavior this keeps track whenever the placeholder option (with class) is selected,
     * it applies a placeholder class to the field to change its styles too.
     */
    const applyPlaceholderStyle = (isPlaceholderSelected) => {
        renderState(
            isPlaceholderSelected ? views.field.placeholder : views.field.standard,
            validElements.select
        );
    };

    /**
     * Handle select change event
     * Placeholder style must be applied on initialization and also in every change dispatching the action to
     */
    const handleChange = () => {
        const type = selectedOptionIsPlaceholder() ? actions.types.true : actions.types.false;
        dispatch({ type });
    };

    /**
     * Check if the selected option have the placeholder class
     */
    const selectedOptionIsPlaceholder = () => {
        const selectedOption = validElements.select.options[validElements.select.selectedIndex];

        return selectedOption.classList.contains(componentClasses.optionPlaceholder);
    };

    /**
     * Dispose
     */
    const dispose = () => {
        element[componentName] = null;
        element = null;
        // Remove event listeners
        validElements.select.removeEventListener("change", handleChange, true);
    };

    // Create the store
    const initialState = selectedOptionIsPlaceholder();
    const { dispatch, subscribe, getState } = createStore(reducers.boolReducer, initialState);

    //Insert icons into dds__select__wrapper
    validElements.selectWrapper.insertAdjacentHTML(
        "beforeend",
        chevronDown({ class: componentClasses.chevronIcon })
    );
    validElements.selectWrapper.insertAdjacentHTML(
        "beforeend",
        alertNotice({ class: componentClasses.feedbackIcon })
    );

    subscribe(applyPlaceholderStyle);
    applyPlaceholderStyle(getState());

    // Add event listeners
    validElements.select.addEventListener("change", handleChange, true);

    // Api
    const api = {
        dispose,
    };

    // Assignment
    element[componentName] = api;

    return api;
};
export default Select;
